import {
  faEllipsisV,
  faShare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export function SaveChartImage(props) {
  const isMobileView = document.body.clientWidth <= 768;
  return (
    <>
      <div
        className={
          props.type == 1
            ? `p-2`
            : `p-2 mb-3`
        }
      >
        <div className="flex w-full h-36 md:h-32 xl:h-36  border border-gray-300 rounded-lg  overflow-hidden shadow">
          <div className="flex item-center w-full">
            <img
              src={props.chart?.image}
              alt="Chart"
              className="object-contain w-full ml-2 h-full"
              onClick={props.slide ? props.prop2 : props.prop3}
            />
          </div>
          {/* <p
            className="cursor-pointer text-right mr-2 cursor pointer px-1"
            onClick={() => props.onShareChartClick(props.chart)}
          >
            <FontAwesomeIcon icon={faArrowUpFromBracket} />
          </p> */}

          <div className=" relative inline-block  text-right mr-4">
            <button
              onClick={() => props.toggleDropdown1(props?.index)}
              type="button"
              className="w-full bg-white-400 text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
            >
              <FontAwesomeIcon icon={faEllipsisV} />
            </button>
            {props.dropdownStates1[props?.index] && (
              <div className="z-50  flex flex-col origin-top-right text-green-500 absolute right-1 mt-1 w-28 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 mr-[-10px]">
                {/* <button
                  className="block w-full text-primaryColor px-2.5 py-1 text-sm hover:bg-gray-100 hover:text-gray-900"
                  role="menuitem"
                >
                  <div
                    className="flex ml-1"
                    onClick={() => props.onShareChartClick(props?.chart)}
                  >
                    <FontAwesomeIcon className="ml-1 h-3 mt-1" icon={faShare} />{" "}
                    <p className="ml-1  text-[10px] whitespace-nowrap">
                      Share Chart
                    </p>
                  </div>
                </button> */}
                <button
                  className="block w-full text-primaryColor px-2.5 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                  role="menuitem"
                >
                  <div
                    className="flex ml-2"
                    onClick={() => props.onShareChartDeleteClick(props?.chart)}
                  >
                    <FontAwesomeIcon className="ml-1 h-2.5 mt-1" icon={faTrash} />{" "}
                    <p className="ml-1 text-[10px] whitespace-nowrap">
                      Delete Chart
                    </p>
                  </div>
                </button>
                <button
                  className="block w-full text-primaryColor px-2.5 py-1 text-sm hover:bg-gray-100 hover:text-gray-900"
                  role="menuitem"
                >
                  <div
                    className="flex ml-1"
                    onClick={() => props.shareChartAsPost(props?.chart)}
                  >
                    <FontAwesomeIcon
                      className="ml-1 h-3 mt-1 "
                      icon={faShare}
                    />{" "}
                    <div className="flex flex-col ">
                      <p className="ml-1 text-[10px]">Share Chart</p>
                      <span className="ml-1 text-[10px]"> as Post</span>
                    </div>
                  </div>
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="text-center text-sm font-semibold mt-2">
          {props.chart?.stock_symbol}
        </div>
      </div>
    </>
  );
}
